
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from './client';

// --- Prompts ---

export const usePrompts = () => {
    return useQuery({
        queryKey: ['prompts'],
        queryFn: async () => {
            const response = await api.get('/prompts');
            return response.data;
        }
    });
};

export const useCreatePrompt = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (promptData) => {
            const { files = [], ...rest } = promptData;

            // Upload files to 'prompts' bucket first
            let mediaUrls = [];
            if (files.length > 0) {
                const uploadResults = await Promise.all(
                    files.map(async (file) => {
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('bucket', 'prompts');
                        const res = await api.post('/storage/upload', formData, {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        });
                        return res.data;
                    })
                );
                mediaUrls = uploadResults.map(r => ({
                    url: r.url,
                    path: r.path,
                    name: r.name,
                    type: r.type
                }));
            }

            const response = await api.post('/prompts', { ...rest, mediaUrls });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['prompts'] });
        },
    });
};

export const useUpdatePrompt = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, data }) => {
            const response = await api.put(`/prompts/${id}`, data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['prompts'] });
        },
    });
};

export const useDeletePrompt = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id) => {
            await api.delete(`/prompts/${id}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['prompts'] });
        },
    });
};

// --- System Prompts ---

export const useSystemPrompts = () => {
    return useQuery({
        queryKey: ['system-prompts'],
        queryFn: async () => {
            const response = await api.get('/system-prompts');
            return response.data;
        }
    });
};

export const useCreateSystemPrompt = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (promptData) => {
            const response = await api.post('/system-prompts', promptData);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['system-prompts'] });
        },
    });
};

export const useUpdateSystemPrompt = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, data }) => {
            const response = await api.put(`/system-prompts/${id}`, data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['system-prompts'] });
        },
    });
};

export const useDeleteSystemPrompt = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id) => {
            await api.delete(`/system-prompts/${id}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['system-prompts'] });
        },
    });
};
